import { createCommunityService } from '@radevents/shared';
import api from './api';
export default createCommunityService(api);
